import React from 'react';

export default function TextArea(props) {
  return (
    <textarea data-test-id={props.name} name={props.name} {...props} onChange={props.onChange} spellCheck="true" disabled={props.disabled}>{props.children}</textarea>
  )
}
